import { IEFinderObject } from '@model';
import { ICommunityPost } from '../model';

/**
 * 포스트에서 이미지 배열을 추출하는 헬퍼.
 * pictures 배열이 있으면 우선 사용하고, 없으면 picture 단일 필드로 fallback.
 */
export const getPostImages = (
  post: Pick<ICommunityPost, 'picture' | 'pictures'>
): IEFinderObject<'image'>[] => {
  if (post.pictures?.length) return post.pictures;
  if (post.picture?.key) return [post.picture];
  return [];
};
